<template>
  <div>
    <section class="hero">
      <div class="hero-glow" aria-hidden="true"></div>
      <div class="shell hero-layout">
        <div class="hero-copy">
          <div class="eyebrow"><span class="eyebrow-line"></span>ВИДЕОНАБЛЮДЕНИЕ ПОД КЛЮЧ</div>
          <h1>Спокойствие<br />В вашем<br /><span class="gradient-text">поле зрения</span></h1>
          <p class="hero-description">
            Всё, что важно, — под присмотром.<br />Подберём камеры, установим и объединим<br
              class="desktop-break"
            />
            в одной удобной системе.
          </p>
          <div class="hero-buttons">
            <a class="button button-primary" href="#calculator">Подобрать решение</a
            ><a class="button button-quiet" href="#system"
              ><span class="play-icon" aria-hidden="true">▷</span> Познакомиться с системой</a
            >
          </div>
        </div>
        <div class="hero-visual" aria-label="Профессиональная камера видеонаблюдения">
          <div class="camera-image"></div>
          <div class="orbit orbit-one" aria-hidden="true"></div>
          <div class="orbit orbit-two" aria-hidden="true"></div>
          <div class="floating-caption">
            <span class="lens-symbol" aria-hidden="true"></span
            ><span>Ваш объект<br /><strong>Вся картина</strong></span>
          </div>
          <span class="hero-coordinate" aria-hidden="true">59°56′ N &nbsp; 30°18′ E</span>
        </div>
      </div>
      <div class="shell hero-bottom">
        <span>Оборудование. Установка. Собственное ПО.</span
        ><a href="#solutions">Откройте больше <span aria-hidden="true">⌄</span></a>
      </div>
    </section>
    <div class="principles shell">
      <div>
        <p><strong>Одна система</strong><span>Камеры и архив в одном интерфейсе</span></p>
      </div>
      <div>
        <p><strong>Записи остаются у вас</strong><span>Архив хранится на вашем объекте</span></p>
      </div>
      <div>
        <p><strong>От идеи до включения</strong><span>Подбор, монтаж и настройка</span></p>
      </div>
    </div>
  </div>
</template>
